import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=cd189d5a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd189d5a')) {
      api.createRecord('cd189d5a', component.options)
    } else {
      api.reload('cd189d5a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=cd189d5a&", function () {
      api.rerender('cd189d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UxKOg6aFscaW/JS/comp/FavElement.vue"
export default component.exports